import React, {CSSProperties, FC} from 'react';
import {Row} from 'react-table';

import {DataFieldsTableData} from '../../models/api/dataFieldsTableModel';
import {StyledDataFieldsTableCell, StyledDataFieldsTableRow} from './styles';

/*
 * Props.
 */

export interface RuleEditorDataTableRowProps {
  row: Row<DataFieldsTableData>;
  style: CSSProperties;
}

/*
 * Component.
 */

export const DataFieldsTableRow: FC<RuleEditorDataTableRowProps> = ({row, style}) => (
  <StyledDataFieldsTableRow {...row.getRowProps({style})}>
    {row.cells.map((cell) => (
      <StyledDataFieldsTableCell {...cell.getCellProps()}>{cell.render('Cell')}</StyledDataFieldsTableCell>
    ))}
  </StyledDataFieldsTableRow>
);
